import { render, staticRenderFns } from "./skuModal.vue?vue&type=template&id=3630c942&scoped=true"
import script from "./skuModal.vue?vue&type=script&lang=js"
export * from "./skuModal.vue?vue&type=script&lang=js"
import style0 from "./skuModal.vue?vue&type=style&index=0&id=3630c942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630c942",
  null
  
)

export default component.exports